import axios from 'axios'

export default function (context, {PartnerId, id}) {
    context.state.options.contragentLegals = [];
    axios({
        method: 'POST',
        url: '/tourclient/masterAgent/dictionary/partnerLegal/list',
        data: {request: JSON.stringify({PartnerId: PartnerId})},
    }).then(({data}) => {
        let main = id;
        if (!main) {
            data.Items.forEach(i => {
                if (i.IsMain) main = i.Id;
                context.state.options.contragentLegals.push({
                    value: i.Id,
                    label: i.Name || i.NameFull,
                });
            });
            main = main ? main : (context.state.options.contragentLegals[0] ? context.state.options.contragentLegals[0].value : '')
        }
        context.commit('set', {
            PartnerLegalId: main
        });
    });
}